const industryTypes = [
  {
    IndustryTypeId: 1,
    Name: 'Beauty Supplies',
    Description: 'Service Establishment Equipment and Supplies',
    SicCode: 5087,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5122,
    IndustryCode: '44612',
  },
  {
    IndustryTypeId: 2,
    Name: 'Butchers',
    Description: 'Meat and Fish (Seafood) Markets, including Freezer Provisioners',
    SicCode: 5421,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5499,
    IndustryCode: '4245',
  },
  {
    IndustryTypeId: 3,
    Name: 'Building Supplies',
    Description: 'Retail-Building Materials, Hardware, Garden Supply',
    SicCode: 5200,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5211,
    IndustryCode: '44419',
  },
  {
    IndustryTypeId: 4,
    Name: 'Car/Auto Parts & Accessories Shop',
    Description: 'Auto and Home Supply Stores',
    SicCode: 5531,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5533,
    IndustryCode: '8111',
  },
  {
    IndustryTypeId: 5,
    Name: 'Charity Shop',
    Description: 'Used Merchandise Stores',
    SicCode: 5932,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5999,
    IndustryCode: '453998',
  },
  {
    IndustryTypeId: 6,
    Name: 'Clothing Shop (Apparel/Fashion)',
    Description: 'Retail-Apparel & Accessory Stores',
    SicCode: 5600,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5611,
    IndustryCode: '44811',
  },
  {
    IndustryTypeId: 7,
    Name: 'E-Cigarette/Vape Shop',
    Description: 'Tobacco Stores and Stands',
    SicCode: 5993,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5993,
    IndustryCode: '3122',
  },
  {
    IndustryTypeId: 8,
    Name: 'Electronics Retailer',
    Description: 'Radio, Television, and Consumer Electronics Stores',
    SicCode: 5731,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5732,
    IndustryCode: '443142',
  },
  {
    IndustryTypeId: 9,
    Name: 'Book Store',
    Description: 'Book Stores',
    SicCode: 5942,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5192,
    IndustryCode: '42492',
  },
  {
    IndustryTypeId: 10,
    Name: 'Music Store',
    Description: 'Record and Prerecorded Tape Stores',
    SicCode: 5735,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5733,
    IndustryCode: '45114',
  },
  {
    IndustryTypeId: 11,
    Name: 'Farm/Ranch supplies',
    Description: 'Farm Supplies',
    SicCode: 5191,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5261,
    IndustryCode: '44411',
  },
  {
    IndustryTypeId: 12,
    Name: 'Florist',
    Description: 'Flower Shop',
    SicCode: 5193,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5193,
    IndustryCode: '42493',
  },
  {
    IndustryTypeId: 13,
    Name: 'Garden Centre (Garden Materials)',
    Description: 'Retail Nurseries, Lawn and Garden Supply Stores',
    SicCode: 5261,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5261,
    IndustryCode: '44411',
  },
  {
    IndustryTypeId: 15,
    Name: 'Gift Shop',
    Description: 'Gift, Card, Novelty, Souvenir Shops',
    SicCode: 5947,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5947,
    IndustryCode: '45322',
  },
  {
    IndustryTypeId: 16,
    Name: 'Guns & tactical gear',
    Description: 'Sporting Goods Stores and Bicycle Shops',
    SicCode: 5941,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5941,
    IndustryCode: '45111',
  },
  {
    IndustryTypeId: 17,
    Name: 'Home Goods (Furniture & Home Decor)',
    Description: 'Retail-Home Furniture, Furnishings & Equipment Stores',
    SicCode: 5700,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5200,
    IndustryCode: '44411',
  },
  {
    IndustryTypeId: 18,
    Name: 'Jewellery Shop (Jewelry)',
    Description: 'Retail-Jewelry Stores',
    SicCode: 5944,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5944,
    IndustryCode: '44831',
  },
  {
    IndustryTypeId: 19,
    Name: 'Off-licence (Liquor Store)',
    Description: 'Wine, Liquor Stores',
    SicCode: 5921,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5921,
    IndustryCode: '4453',
  },
  {
    IndustryTypeId: 20,
    Name: 'Pawn shop',
    Description: 'Used Merchandise Stores',
    SicCode: 5932,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5933,
    IndustryCode: '',
  },
  {
    IndustryTypeId: 21,
    Name: 'Pet Store (Pets & Supplies)',
    Description: 'Animal, Pet Shops',
    SicCode: 5995,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5995,
    IndustryCode: '45391,',
  },
  {
    IndustryTypeId: 22,
    Name: 'Petrol Station (Gas Station)',
    Description: 'Gasoline Service Stations',
    SicCode: 5541,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5541,
    IndustryCode: '447',
  },
  {
    IndustryTypeId: 23,
    Name: 'Pharmacy (Drug Store/Chemist)',
    Description: 'Drug Stores and Proprietary Stores',
    SicCode: 5921,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5912,
    IndustryCode: '44611',
  },
  {
    IndustryTypeId: 24,
    Name: 'Reseller/Distributor',
    Description: 'Classification is based on the type of goods sold!?',
    SicCode: null,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5999,
    IndustryCode: '453998',
  },
  {
    IndustryTypeId: 25,
    Name: 'Shoe Shop (Footwear)',
    Description: 'Retail-Shoe Stores',
    SicCode: 5661,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5661,
    IndustryCode: '4482',
  },
  {
    IndustryTypeId: 26,
    Name: 'Sporting goods',
    Description: 'Sporting and Athletic Goods',
    SicCode: 3949,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5941,
    IndustryCode: '45111',
  },
  {
    IndustryTypeId: 27,
    Name: 'Supermarket',
    Description: 'Grocery Stores',
    SicCode: 5411,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5411,
    IndustryCode: '311',
  },
  {
    IndustryTypeId: 28,
    Name: 'Tobacco Shop',
    Description: 'Tobacco Stores and Stands',
    SicCode: 5993,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5993,
    IndustryCode: '3122',
  },
  {
    IndustryTypeId: 29,
    Name: 'Tools/Hardware Store',
    Description: 'Retail-Building Materials, Hardware, Garden Supply',
    SicCode: 5200,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5251,
    IndustryCode: '44413',
  },
  {
    IndustryTypeId: 30,
    Name: 'Bar',
    Description: 'Drinking Places',
    SicCode: 5813,
    VerticalMarketId: 2,
    MerchantCategoryCode: 5813,
    IndustryCode: '7224',
  },
  {
    IndustryTypeId: 31,
    Name: 'Café',
    Description: 'Eating Places',
    SicCode: 5812,
    VerticalMarketId: 2,
    MerchantCategoryCode: 5462,
    IndustryCode: '311811',
  },
  {
    IndustryTypeId: 32,
    Name: 'Coffee shop/house',
    Description: 'Eating Places',
    SicCode: 5812,
    VerticalMarketId: 2,
    MerchantCategoryCode: 5462,
    IndustryCode: '311811',
  },
  {
    IndustryTypeId: 33,
    Name: " Gentlemen's Club",
    Description: 'Eating Places',
    SicCode: 5812,
    VerticalMarketId: 2,
    MerchantCategoryCode: 7997,
    IndustryCode: '7139B',
  },
  {
    IndustryTypeId: 34,
    Name: 'Hotel',
    Description: 'Hotels and Motels',
    SicCode: 7011,
    VerticalMarketId: 2,
    MerchantCategoryCode: 3501,
    IndustryCode: '72111',
  },
  {
    IndustryTypeId: 35,
    Name: 'Night Club',
    Description: 'Drinking Places',
    SicCode: 5813,
    VerticalMarketId: 2,
    MerchantCategoryCode: 5813,
    IndustryCode: '7224',
  },
  {
    IndustryTypeId: 36,
    Name: 'Restaurant',
    Description: 'Eating Places',
    SicCode: 5812,
    VerticalMarketId: 2,
    MerchantCategoryCode: 5812,
    IndustryCode: '722511',
  },
  {
    IndustryTypeId: 37,
    Name: 'Social/Members Club',
    Description: 'Eating and Drinking Places',
    SicCode: 5810,
    VerticalMarketId: 2,
    MerchantCategoryCode: 7997,
    IndustryCode: '7139B',
  },
  {
    IndustryTypeId: 38,
    Name: 'Salon/Hairdresser/Barber',
    Description: 'Barber Shops',
    SicCode: 7241,
    VerticalMarketId: 3,
    MerchantCategoryCode: 7230,
    IndustryCode: '81211',
  },
  {
    IndustryTypeId: 39,
    Name: 'Beauty Salon',
    Description: 'Beauty Shops',
    SicCode: 7231,
    VerticalMarketId: 3,
    MerchantCategoryCode: 7298,
    IndustryCode: '8121B',
  },
  {
    IndustryTypeId: 40,
    Name: 'Nail Bar',
    Description: 'Beauty Shops',
    SicCode: 7231,
    VerticalMarketId: 3,
    MerchantCategoryCode: 7230,
    IndustryCode: '81211',
  },
  {
    IndustryTypeId: 41,
    Name: 'Massage/Therapy Centre',
    Description: 'null',
    SicCode: null,
    VerticalMarketId: 3,
    MerchantCategoryCode: 7297,
    IndustryCode: '8121A',
  },
  {
    IndustryTypeId: 42,
    Name: 'Spa',
    Description: 'null',
    SicCode: null,
    VerticalMarketId: 3,
    MerchantCategoryCode: 7298,
    IndustryCode: '8121B',
  },
  {
    IndustryTypeId: 43,
    Name: 'Gym',
    Description: 'Physical Fitness Facilities',
    SicCode: 7991,
    VerticalMarketId: 3,
    MerchantCategoryCode: 7997,
    IndustryCode: '7139B',
  },
  {
    IndustryTypeId: 44,
    Name: 'Car Wash',
    Description: 'Car Wash',
    SicCode: 7542,
    VerticalMarketId: 3,
    MerchantCategoryCode: 7542,
    IndustryCode: '8111',
  },
  {
    IndustryTypeId: 45,
    Name: 'Dry Cleaners',
    Description: 'Dry Cleaning',
    SicCode: 7216,
    VerticalMarketId: 3,
    MerchantCategoryCode: 7216,
    IndustryCode: '8123',
  },
  {
    IndustryTypeId: 46,
    Name: 'Repair Shop',
    Description: 'Apparel Tailors/Seamstress/Mending/Alternations',
    SicCode: 2741,
    VerticalMarketId: 3,
    MerchantCategoryCode: 7379,
    IndustryCode: '8112',
  },
  {
    IndustryTypeId: 47,
    Name: 'Activity/Play Centre',
    Description: 'Amusement and Recreation Services',
    SicCode: 7900,
    VerticalMarketId: 4,
    MerchantCategoryCode: 7993,
    IndustryCode: '71312',
  },
  {
    IndustryTypeId: 48,
    Name: 'Cafe/Shop combined',
    Description: 'Eating Places',
    SicCode: 5812,
    VerticalMarketId: 4,
    MerchantCategoryCode: 5462,
    IndustryCode: '311811',
  },
  {
    IndustryTypeId: 49,
    Name: 'Cash & Carry',
    Description: 'Wholesale Trade - Nondurable Goods',
    SicCode: 5100,
    VerticalMarketId: 4,
    MerchantCategoryCode: 5411,
    IndustryCode: '311',
  },
  {
    IndustryTypeId: 50,
    Name: 'Entertainment Cinema/Ten Pin Bowling/Trampoline Park',
    Description: 'Amusement and Recreation Services',
    SicCode: 7900,
    VerticalMarketId: 4,
    MerchantCategoryCode: 7993,
    IndustryCode: '71312',
  },
  {
    IndustryTypeId: 51,
    Name: 'Leisure Centre',
    Description: 'Services-Membership Sports & Recreation Clubs',
    SicCode: 7997,
    VerticalMarketId: 4,
    MerchantCategoryCode: 7993,
    IndustryCode: '71312',
  },
  {
    IndustryTypeId: 52,
    Name: 'Museum',
    Description: 'Museums and Art Galleries',
    SicCode: 8412,
    VerticalMarketId: 4,
    MerchantCategoryCode: 7991,
    IndustryCode: '712',
  },
  {
    IndustryTypeId: 53,
    Name: 'Stadium/Arena',
    Description: 'Professional Sports Clubs and Promoters',
    SicCode: 7941,
    VerticalMarketId: 4,
    MerchantCategoryCode: 7941,
    IndustryCode: '7113',
  },
  {
    IndustryTypeId: 54,
    Name: 'University/College',
    Description: 'Colleges, Universities, and Professional Schools',
    SicCode: 8221,
    VerticalMarketId: 4,
    MerchantCategoryCode: 8220,
    IndustryCode: '6113',
  },
  {
    IndustryTypeId: 56,
    Name: 'Fast Food/Quick Service Restaurant',
    Description: 'Eating Places',
    SicCode: 5812,
    VerticalMarketId: 5,
    MerchantCategoryCode: 5812,
    IndustryCode: '722511',
  },
  {
    IndustryTypeId: 57,
    Name: 'Retail Popup',
    Description: 'Miscellaneous Retail Stores',
    SicCode: 5999,
    VerticalMarketId: 5,
    MerchantCategoryCode: 5999,
    IndustryCode: '453998',
  },
  {
    IndustryTypeId: 58,
    Name: 'Takeaway or Bakery/Deli (no seating)',
    Description: 'Bakery',
    SicCode: 5461,
    VerticalMarketId: 5,
    MerchantCategoryCode: 5462,
    IndustryCode: '311811',
  },
  {
    IndustryTypeId: 60,
    Name: 'Deli',
    Description: 'Deli',
    SicCode: null,
    VerticalMarketId: 2,
    MerchantCategoryCode: 5411,
    IndustryCode: '311',
  },
  {
    IndustryTypeId: 61,
    Name: 'Bakery',
    Description: 'Bakery',
    SicCode: null,
    VerticalMarketId: 2,
    MerchantCategoryCode: 5462,
    IndustryCode: '311811',
  },
  {
    IndustryTypeId: 62,
    Name: 'Professional Sports Club',
    Description: 'Professional Sports Club',
    SicCode: null,
    VerticalMarketId: 4,
    MerchantCategoryCode: 7941,
    IndustryCode: '7113',
  },
  {
    IndustryTypeId: 63,
    Name: 'Newsagent',
    Description: 'Newsagent',
    SicCode: null,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5994,
    IndustryCode: '51911',
  },
  {
    IndustryTypeId: 64,
    Name: 'Convenience Store',
    Description: 'Convenience Store',
    SicCode: null,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5411,
    IndustryCode: '311',
  },
  {
    IndustryTypeId: 65,
    Name: 'Grocery Shop',
    Description: 'Grocery Shop',
    SicCode: null,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5411,
    IndustryCode: '311',
  },
  {
    IndustryTypeId: 66,
    Name: 'Gaming Store',
    Description: 'Gaming Store',
    SicCode: null,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5816,
    IndustryCode: '5112B',
  },
  {
    IndustryTypeId: 67,
    Name: 'Specialist Retail Store',
    Description: 'Specialist Retail Store',
    SicCode: null,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5999,
    IndustryCode: '453998',
  },
  {
    IndustryTypeId: 69,
    Name: 'Arts and Craft',
    Description: 'Arts and Craft',
    SicCode: null,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5971,
    IndustryCode: '45392',
  },
  {
    IndustryTypeId: 70,
    Name: 'Rental Services',
    Description: 'Rental Services',
    SicCode: null,
    VerticalMarketId: 3,
    MerchantCategoryCode: 7394,
    IndustryCode: '53221',
  },
  {
    IndustryTypeId: 71,
    Name: 'Brewery/Distillery',
    Description: 'Brewery/Distillery',
    SicCode: null,
    VerticalMarketId: 2,
    MerchantCategoryCode: 5813,
    IndustryCode: '7224',
  },
  {
    IndustryTypeId: 72,
    Name: 'Printing Services',
    Description: 'Printing Services',
    SicCode: null,
    VerticalMarketId: 3,
    MerchantCategoryCode: 2741,
    IndustryCode: '323',
  },
  {
    IndustryTypeId: 73,
    Name: 'Discount Store',
    Description: 'Discount Store',
    SicCode: null,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5310,
    IndustryCode: '4539H',
  },
  {
    IndustryTypeId: 74,
    Name: 'Education Centre',
    Description: 'Education Centre',
    SicCode: null,
    VerticalMarketId: 4,
    MerchantCategoryCode: 8299,
    IndustryCode: '61161',
  },
  {
    IndustryTypeId: 76,
    Name: 'Toy Store',
    Description: 'Toy Store',
    SicCode: null,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5945,
    IndustryCode: '45112',
  },
  {
    IndustryTypeId: 77,
    Name: 'Sports Centre/Sports Club',
    Description: 'Sports Centre/Sports Club',
    SicCode: null,
    VerticalMarketId: 3,
    MerchantCategoryCode: 7941,
    IndustryCode: '71394',
  },
  {
    IndustryTypeId: 78,
    Name: 'Health and Fitness Store',
    Description: 'Health and Fitness Store',
    SicCode: null,
    VerticalMarketId: 1,
    MerchantCategoryCode: 7991,
    IndustryCode: '712',
  },
  {
    IndustryTypeId: 79,
    Name: 'Holiday Park',
    Description: 'Holiday Park',
    SicCode: null,
    VerticalMarketId: 4,
    MerchantCategoryCode: 7991,
    IndustryCode: '712',
  },
  {
    IndustryTypeId: 80,
    Name: 'Pub',
    Description: 'Pub',
    SicCode: null,
    VerticalMarketId: 2,
    MerchantCategoryCode: 5813,
    IndustryCode: '7224',
  },
  {
    IndustryTypeId: 81,
    Name: 'Office Supplies',
    Description: 'Office Supplies',
    SicCode: null,
    VerticalMarketId: 1,
    MerchantCategoryCode: 5943,
    IndustryCode: '45321',
  },
  {
    IndustryTypeId: 83,
    Name: 'Amusement Centre',
    Description: 'Amusement Centre',
    SicCode: null,
    VerticalMarketId: 4,
    MerchantCategoryCode: 7996,
    IndustryCode: '71311',
  },
];

export default industryTypes;
